module.exports = __webpack_public_path__ + "static/media/gamesWon_500000.b22b5c95.png";